import { archivoYaGuardado } from './descargas-en-curso';
import { saveAs } from 'file-saver';

/** Tipo de un .xlsx: sin él, el navegador puede guardarlo como binario sin extensión. */
export const TIPO_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Guarda un archivo que vino del servidor con su nombre (Mario, 08-oct: en mt-app los Excel bajaban como un
 * UUID sin extensión). Antes cada pantalla armaba un enlace con URL.createObjectURL y lo liberaba en el mismo
 * instante del clic: Chrome perdía el nombre. file-saver espera a que la descarga arranque.
 */
export function guardarArchivo(blob: Blob, nombre: string, tipo = TIPO_XLSX): void {
  if (archivoYaGuardado(blob)) return;
  saveAs(blob.type === tipo ? blob : new Blob([blob], { type: tipo }), nombre);
}
